<template>
	<div class="media-details__info">
		<div class="popup-label mb--20">{{ t('popup.media.upload.overview') }}</div>
		<div class="field-label mb--10">{{ t('popup.media.upload.video') }} (m4p, mpeg, mov, webm, mkv):</div>
		<div class="typo-item fs--15 fw--300 lh--18 color--greeny-blue pb--10 border--b border--b-dotted border--width-2 border--color-black mb--25">
			{{ t('popup.media.upload.fileLimit', {size: 500}) }}<br>
			{{ t('popup.media.upload.videoOptimal') }}
			<div class="typo-item fs--15 color--rosy-pink" v-if="isVideoSizeExceeded">{{ t('popup.media.message.sizeExceeded') }}</div>
		</div>
		<div class="field-label mb--10">{{ t('popup.media.upload.images') }} (png, jpg, jpeg, gif):</div>
		<div class="typo-item fs--15 fw--300 lh--18 color--greeny-blue pb--10 border--b border--b-dotted border--width-2 border--color-black mb--25">
			{{ t('popup.media.upload.fileLimit', {size: 5}) }}
			<div class="typo-item fs--15 color--rosy-pink" v-if="isImageSizeExceeded">{{ t('popup.media.message.sizeExceeded') }}</div>
		</div>
		<div class="field-label mb--10">{{ t('popup.media.upload.vector') }} (svg):</div>
		<div class="typo-item fs--15 fw--300 lh--18 color--greeny-blue pb--10 border--b border--b-dotted border--width-2 border--color-black mb--25">
			{{ t('popup.media.upload.noLimit') }}
		</div>
		<div class="field-label mb--10">{{ t('popup.media.upload.audio') }} (mp3, opus, ogg):</div>
		<div class="typo-item fs--15 fw--300 lh--18 color--greeny-blue pb--10 border--b border--b-dotted border--width-2 border--color-black mb--25">
			{{ t('popup.media.upload.fileLimit', {size: 10}) }}
			<div class="typo-item fs--15 color--rosy-pink" v-if="isAudioSizeExceeded">{{ t('popup.media.message.sizeExceeded') }}</div>
		</div>
		<div class="field-label mb--10">Lottie (.lottie, .lot, .json):</div>
		<div class="typo-item fs--15 fw--300 lh--18 color--greeny-blue pb--10 border--b border--b-dotted border--width-2 border--color-black mb--25">
			{{ t('popup.media.upload.fileLimit', {size: 5}) }}
			<div class="typo-item fs--15 color--rosy-pink" v-if="isLottieSizeExceeded">{{ t('popup.media.message.sizeExceeded') }}</div>
		</div>
		<div class="field-label mb--10">{{ t('popup.media.upload.other') }} (ppt, pdf, doc, docx, txt, zip): </div>
		<div class="typo-item fs--15 fw--300 lh--18 color--greeny-blue pb--10 border--b border--b-dotted border--width-2 border--color-black mb--25">
			{{ t('popup.media.upload.fileLimit', {size: 500}) }}
			<div class="typo-item fs--15 color--rosy-pink" v-if="isDocumentSizeExceeded">{{ t('popup.media.message.sizeExceeded') }}</div>
		</div>
	</div>
</template>

<script>
import {useI18n} from "vue-i18n";
import {computed} from "vue";

export default {
	props: {
		files: {
			required: true
		}
	},
	setup(props){
		const {t} = useI18n();
		
		const isSingleFileUploading = computed(() => props.files.length === 1);
		
		const isImageSizeExceeded = computed(() => isSingleFileUploading.value && props.files[0].type.includes('image') && props.files[0].size/ (1024 * 1024) > 5);
		const isAudioSizeExceeded = computed(() => isSingleFileUploading.value && props.files[0].type.includes('audio') && props.files[0].size/ (1024 * 1024) > 10);
		const isVideoSizeExceeded = computed(() => isSingleFileUploading.value && props.files[0].type.includes('video') && props.files[0].size/ (1024 * 1024) > 500);
		const isDocumentSizeExceeded = computed(() => isSingleFileUploading.value && props.files[0].type.includes('application') && props.files[0].size/ (1024 * 1024) > 500);
		const isLottieSizeExceeded = computed(() => isSingleFileUploading.value && /\.(lot|lottie|lottie\.json|json)$/i.test(props.files[0].name) && props.files[0].size/ (1024 * 1024) > 5);

		return{
			t,
			isImageSizeExceeded,
			isAudioSizeExceeded,
			isVideoSizeExceeded,
			isDocumentSizeExceeded,
			isLottieSizeExceeded
		}
	}
}
</script>

<style lang="scss">
@use "@/scss/sections/editor/media/media-info";
</style>